import { gql, TypedDocumentNode } from '@common/hooks';
import { ClinicalSpecialtyType } from '@clinician-profile/graphql';

type ClinicalSpecialtiesQueryResponse = {
  clinicalSpecialties: ClinicalSpecialtyType[];
};

export const ClinicalSpecialtiesQuery: TypedDocumentNode<ClinicalSpecialtiesQueryResponse> = gql`
  query ClinicalSpecialties {
    clinicalSpecialties {
      id
      displayName
    }
  }
`;
